{{#if rotateLeft}}<i class="fa fa-arrow-left"></i>{{/if}} {{value}} {{#if rotateRight}}<i class="fa fa-arrow-right"></i>{{/if}}
